import { cn } from '@talentbabu/ui';
import { Link } from 'react-router';

/** `inverted` (dark surfaces) uses the white-wordmark artwork; otherwise the navy one. */
export function Logo({
  className,
  imgClassName,
  inverted = false,
  to = '/',
}: {
  className?: string;
  imgClassName?: string;
  inverted?: boolean;
  to?: string;
}) {
  return (
    <Link to={to} className={cn('inline-flex items-center', className)} aria-label="TalentBabu home">
      <img
        src={inverted ? '/brand/logo-light.webp' : '/brand/logo.webp'}
        alt="TalentBabu"
        width={1200}
        height={290}
        className={cn('h-10 w-auto', imgClassName)}
      />
    </Link>
  );
}
